// extracted by mini-css-extract-plugin
module.exports = {"submitButtons":"SubmitSection_submitButtons__VqqHb","link":"SubmitSection_link__z3J_u"};